import { DEFAULT_LANGUAGE } from '../config';

export const fetchListing = (service, collectionName, queryOptions) => {
  const _queryOptions = typeof queryOptions === 'string' ? JSON.parse(queryOptions) : queryOptions.slice();
  const opts = _queryOptions[1] || {};
  let promiseGetTotal = null;
  if (!opts.withoutTotal) {
    const queryTotal = [['id'], { where: opts.where }];
    promiseGetTotal = service.countObjects(collectionName, opts.where);
  }
  return Promise.all([service.fetchObjects([collectionName].concat(_queryOptions)), promiseGetTotal])
  .then(res => {
    const objects = res[0];
    if (opts.withoutTotal) return { objects }; // Return objects only without total
    const totalObjects = res[1];
    let totalPages = 1;
    if (opts.limit) totalPages = Math.ceil(totalObjects / opts.limit);
    return { objects, totalPages, totalObjects };
  });
};

export const sendJson = (res, status) => (result) => {
  return res.status(status || 200).json(result);
};
export const sendError = (res, status) => (error) => {
  console.error('ERROR', error);
  const errorMessage = error && typeof error === 'object' ? error.message : error;
  return res.status(status || 500).json({ error: errorMessage });
};
export const deleted = (res) => () => {
  return sendJson(res)({ deleted: 'ok' });
};

export const slugify = (name) => {
  let str = (name || '').replace(/^\s+|\s+$/g, ''); // trim
  str = str.toLowerCase();
  // remove accents, swap ñ for n, etc
  const from = 'àáäâèéëêìíïîòóöôùúüûñç·/_,:;';
  const to = 'aaaaeeeeiiiioooouuuunc------';
  for (let i = 0, l = from.length; i < l; i++) {
    str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
  }
  str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
    .replace(/\s+/g, '-') // collapse whitespace and replace by -
    .replace(/-+/g, '-'); // collapse dashes
  return str;
};

export const i18n = (translations, locale = null) => {
  if (!translations || !translations.$i18n) return '';
  const _locale = locale || DEFAULT_LANGUAGE;
  return translations.$i18n[locale] || translations.$i18n[DEFAULT_LANGUAGE];
};



// WEBPACK FOOTER //
// ./src/backend/helpers.js